// types
import { ContactsActionTypes, ContactsState } from "./types";

export const INIT_STATE: ContactsState = {
  contacts: [],
  contactsPage: 0,
  contactsTotal: 0,
  contactsHasMore: true,
  contactsPageLoading: false,
};

const Contacts = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ContactsActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case ContactsActionTypes.GET_CONTACTS:
          return {
            ...state,
            contacts: action.payload.data,
            isContactsFetched: true,
            getContactsLoading: false,
          };
        case ContactsActionTypes.GET_CONTACTS_PAGE: {
          const { contacts, total, page, hasMore } = action.payload.data;
          return {
            ...state,
            // page 1 replaces list; subsequent pages append
            contacts: page === 1 ? contacts : [...state.contacts, ...contacts],
            contactsPage: page,
            contactsTotal: total,
            contactsHasMore: hasMore,
            contactsPageLoading: false,
          };
        }
        case ContactsActionTypes.INVITE_CONTACT:
          return {
            ...state,
            isContactInvited: true,
          };
        default:
          return { ...state };
      }

    case ContactsActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case ContactsActionTypes.GET_CONTACTS:
          return {
            ...state,
            isContactsFetched: false,
            getContactsLoading: false,
          };
        case ContactsActionTypes.GET_CONTACTS_PAGE:
          return {
            ...state,
            contactsPageLoading: false,
          };
        case ContactsActionTypes.INVITE_CONTACT:
          return {
            ...state,
            isContactInvited: false,
          };
        default:
          return { ...state };
      }

    case ContactsActionTypes.GET_CONTACTS: {
      return {
        ...state,
        getContactsLoading: true,
        isContactsFetched: false,
      };
    }

    case ContactsActionTypes.GET_CONTACTS_PAGE: {
      const { page } = action.payload;
      return {
        ...state,
        contactsPageLoading: true,
        // reset list when fetching first page
        contacts: page === 1 ? [] : state.contacts,
      };
    }

    case ContactsActionTypes.INVITE_CONTACT:
      return {
        ...state,
        isContactInvited: false,
      };
    case ContactsActionTypes.RESET_CONTACTS: {
      const flag = action.payload.flag;
      const value = action.payload.value;
      const flags: any = {};
      flags[flag] = value;
      return {
        ...state,
        ...flags,
      };
    }
    default:
      return { ...state };
  }
};

export default Contacts;
